import React, { useState } from 'react';
import { useTranslate, useGetIdentity } from 'react-admin';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

import Leaderboard from './Leaderboard';
import Battle from './Battle';
import AchievementsGrid from '../../../account/AchievementsGrid';


const StatsTab = () => {
    const [currentTab, setCurrentTab] = useState('leaderboard');
    const { data: account } = useGetIdentity();
    const translate = useTranslate();

    return (
        <Card sx={{ mt: 2 }}>
            <CardContent>
                <ButtonGroup variant="outlined" size="small">
                    <Button variant={currentTab === 'leaderboard' ? 'contained': 'outlined'} onClick={() => setCurrentTab('leaderboard')}>{translate('Leaderboard')}</Button>
                    <Button variant={currentTab === 'achievements' ? 'contained': 'outlined'} onClick={() => setCurrentTab('achievements')}>{translate('Achievements')}</Button>
                    <Button variant={currentTab === 'battle' ? 'contained': 'outlined'} onClick={() => setCurrentTab('battle')}>{translate('My impact')}</Button>
                </ButtonGroup>

                {currentTab === 'leaderboard' && (
                    <Leaderboard />
                )}
                {currentTab === 'achievements' && (
                    <AchievementsGrid userId={account?.id} />
                )}
                {currentTab === 'battle' && (
                    <Battle />
                )}
            </CardContent>
        </Card>
    );
};

export default StatsTab;